import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { useEnquiryModal } from "./EnquiryModal";

const FooterMain = () => {
    const { openModal } = useEnquiryModal();
    return (
        <div>
            <footer className="bg-[#003153] text-white py-12 px-6 md:px-20">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Logo & Text */}
                    <div className="-mt-7">
                        {/* <h2 className="text-3xl font-bold tracking-wide">NOVA</h2> */}
                        <img src="../Assets/project_logo.webp" alt="logo" className="w-48 items-start invert" />
                        <p className="text-md md:mt-4 mt-0 max-w-md leading-relaxed">
                            We specialize in connecting discerning clients with the finest
                            properties Dubai has to offer.
                        </p>
                    </div>

                    {/* Specialization */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div>
                            <h3 className="text-lg font-semibold mb-3">Specialization</h3>
                            <ul className="space-y-2 text-sm">
                                <li><Link to="/" className="hover:text-gray-300">Buy</Link></li>
                                <li><Link to="/" className="hover:text-gray-300">Sell</Link></li>
                                <li><Link to="/new-projects" className="hover:text-gray-300">Off Plan</Link></li>
                                <li><Link to="/projects" className="hover:text-gray-300">Luxury Properties</Link></li>
                            </ul>
                        </div>

                        {/* Quick Links */}
                        <div>
                            <h3 className="text-lg font-semibold mb-3">Quick Links</h3>
                            <ul className="space-y-2 text-sm">
                                <li><Link to="/" className="hover:text-gray-300">Home</Link></li>
                                <li><Link to="/about" className="hover:text-gray-300">About us</Link></li>
                                <li><Link to="/projects" className="hover:text-gray-300">Projects</Link></li>
                                <li><Link to="/new-projects" className="hover:text-gray-300">New Projects</Link></li>
                                <li><Link to="/contact" className="hover:text-gray-300">Contact us</Link></li>
                            </ul>
                        </div>

                        {/* Social */}
                        <div>
                            <h3 className="text-lg font-semibold mb-3">Stay Connected</h3>
                            <div className="flex space-x-4 text-xl">
                                <a href="https://www.facebook.com/novarealestatedxb/" className="hover:text-gray-300"><FaFacebookF /></a>
                                <a href="https://www.instagram.com/novacapitalrealestate/" className="hover:text-gray-300"><FaInstagram /></a>
                                <a href="https://www.youtube.com/" className="hover:text-gray-300"><FaYoutube /></a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Footer */}
                <div className="border-t pb-10 lg:pb-0 border-white/20 mt-10 pt-6 text-sm flex flex-col md:flex-row justify-between items-center">
                    <p>© 2025 Nova Capital Real Estate L.L.C.</p>
                    <div className="space-x-6 mt-4 md:mt-0">
                        <Link to="/privacy-policy" className="hover:text-gray-300">Privacy Policy | Terms & Conditions</Link>
                        {/* <Link to="/terms" className="hover:text-gray-300">Our Terms</Link> */}
                    </div>
                </div>
            </footer>

            {/* Fixed Mobile Footer Buttons */}
            <div className="fixed bottom-0 left-0 w-full bg-[#003153] shadow-md lg:hidden z-50">
                <div className="justify-around w-full p-2 space-x-2">
                    <button onClick={openModal} className="flex-1 text-center justify-center flex gap-2 w-full items-center p-2 rounded-lg font-semibold bg-[#f6f8f2] text-[#003153] hover:text-white hover:bg-[#003153] transition-colors">
                        <i className="fas fa-envelope text-lg"></i>
                        <span className="text-md mt-1">ENQUIRY</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FooterMain;
